/**
 * Collection of publicly available urls used throughout the application.
 */

let urls: {
  /**
   * Contains the absolute url needed to access the builder for a specific
   * course (this value will need to have the { id } placeholder properly
   * replaced).
   */
  builder: string;

  /**
   * Contains the absolute url needed to access the viewer for a specific
   * course (this value will need to have the { id } placeholder properly
   * replaced).
   */
  viewer: string;

  /**
   * Specifies the base path of the UserData api, so all endpoints will be
   * resolved relatively to this address.
   */
  userData: string;

  gas: (version: "v1" | "v2" | undefined) => string;
};

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
  case "production":
    urls = {
      builder: "https://forloeb.gyldendal.dk/bygger/{ id }/",
      viewer: "https://forloeb.gyldendal.dk/viser/{ id }/",
      userData: "https://userdata-v2.gyldendal.dk/api",
      gas: (version: "v1" | "v2" | undefined) =>
        `https://gdapim-production.azure-api.net/GAS-${version ?? "v"}-Prod/${
          version ?? "v"
        }`,
    };
    break;

  case "staging":
    urls = {
      builder: "https://qa-forloeb.gyldendal.dk/bygger/{ id }/",
      viewer: "https://qa-forloeb.gyldendal.dk/viser/{ id }/",
      userData: "https://qa-userdata.gyldendal.dk/api",
      gas: (version: "v1" | "v2" | undefined) =>
        `https://gdapim-production.azure-api.net/GAS-${version ?? "v"}-QA/${
          version ?? "v"
        }`,
    };
    break;

  default:
    urls = {
      builder: "https://test-forloeb.gyldendal.dk/bygger/{ id }/",
      viewer: "https://test-forloeb.gyldendal.dk/viser/{ id }/",
      userData: "https://test-userdata-v2.gyldendal.dk/api",
      gas: (version: "v1" | "v2" | undefined) =>
        `https://dev-apim.gyldendal.dk/GAS-${version ?? "v"}-Test/${
          version ?? "v"
        }`,
    };
}

// Export configurations publicly
export { urls };
